import { Body, Box, Button, Card, CenteredBox, H3, Pill, Tick } from '../widgets'

export const ModeCard = ({ pillText, duration, title, subtitle, text, buttonText, features, onClick, background, color, tickColor, tickBackground }) => (
  <Card
    container
    column
    alignItems="start"
    justifyContent="start"
    gap={24}
    p="40px 32px"
    maxWidth={450}
    background={background}
    color={color}
    overflow="visible"
  >
    {pillText &&
      <Pill
        background="white"
        color="black"
        position="absolute"
        height={32}
        top={-16}
        alignSelf="center"
        fontWeight={600}
        border="none"
      >
        {pillText}
      </Pill>
    }

    <Pill
      background="black"
      color="white"
      border="none"
      height={32}
      p="0 16px"
    >
      {duration}
    </Pill>

    <Box column gap={12}>
      <H3 align="left" color={color}>{title}</H3>
      <Body bold>{subtitle}</Body>
      <Body weight={400}>{text}</Body>
    </Box>

    <Button fullWidth onClick={onClick}>
      <Box gap={8} alignItems="center">
        {buttonText}
        <svg width="26" height="15" viewBox="0 0 26 15" fill="none">
          <path d="M25.7071 8.07088C26.0976 7.68035 26.0976 7.04719 25.7071 6.65666L19.3431 0.292702C18.9526 -0.0978227 18.3195 -0.0978227 17.9289 0.292702C17.5384 0.683226 17.5384 1.31639 17.9289 1.70692L23.5858 7.36377L17.9289 13.0206C17.5384 13.4111 17.5384 14.0443 17.9289 14.4348C18.3195 14.8254 18.9526 14.8254 19.3431 14.4348L25.7071 8.07088ZM0 7.36377V8.36377H25V7.36377V6.36377H0V7.36377Z" fill="white"/>
        </svg>
      </Box>
    </Button>

    <Box column gap={8}>
      <Body bold>Features</Body>
      {features.map((feature, i) =>
        <Box key={i} gap={10}>
          <CenteredBox size={24} r={12} background={tickBackground}>
            <Tick size={18} fill={tickColor} />
          </CenteredBox>
          <Body weight={400}>{feature}</Body>
        </Box>
      )}
    </Box>
  </Card>
)